/*  Store for data shared across multiple components */
// Copy right - © 2024 tecera gmbh



import { writable } from 'svelte/store';

// shared stores

export const selected_device = writable(null);
export const map_center = writable([52.022146, 10.566208]);
export const backup_map_center = writable([52.022146, 10.566208]);
export const modal_mode = writable('closed');
export const toast_message = writable('');
export const toast_message_error = writable('');
export const current_device_data = writable([]);
export const current_device_data_additional_values = writable([]);
export const last_meta_data = writable(null);
export const is_loading_current_device_data = writable(false);
export const is_modal_open = writable(false);
export const chart = writable(null);
export const all_devices = writable([]);


// Hymo stores

export const all_hymos = writable([]);
export const free_hymos = writable([]);
export const hymo_alarms_triggered_old = writable([]);
export const hymo_alarms_triggered_new = writable([]);


// Watermeter stores

export const all_water_meters = writable([]);
export const all_compound_water_meters = writable([]);
export const free_water_meters = writable([]);
export const water_meter_alarms_triggered_old = writable([]);
export const water_meter_alarms_triggered_new = writable([]);
export const extended_device_channel_list = writable([]);
export const last_meter_readings = writable([]);


// Settings 

export const user_list = writable([]);
export const current_sample_time = writable("Echtzeitwerte");
export const all_water_meter_boxes = writable([]);
export const customer_list = writable([]);



export const alarm_recipient_list = writable([]);

export const hymo_data_end_date = writable(null);
